module.exports = __webpack_public_path__ + "static/media/Homepage-backgroud.e509b7d8.png";